// formatters.js

export function formatarQuantidade(valor) {
    let numero = parseFloat(valor);
    
    if (isNaN(numero)) return "0";

    return numero.toLocaleString('pt-BR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 4
    });
}

export function formatarValor(valor) {
    let numero = typeof valor === 'string' ? 
        parseFloat(valor.replace(',', '.')) : valor;

    if (isNaN(numero)) {
        return 'R$ 0,00';
    }

    return numero.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });
}
